import { Typography } from "@mui/material";
import React from "react";

export default function TextCustomerBankInfoValue({ children, ...props }) {
  return (
    <Typography
      {...props}
      sx={{
        display: "-webkit-box",
        overflow: "hidden",
        WebkitBoxOrient: "vertical",
        WebkitLineClamp: 1,
      }}
      variant="caption"
      fontWeight={600}
      color="#FFFFFF"
    >
      {children}
    </Typography>
  );
}
